<template>
    <div class="company-information-form-locked">
        <CompassFormItem
            :label="$t.__('CompanyInformation.legal_information.country_label')"
            orientation="horizontal"
        >
            <span class="typographies-paragraph-medium-regular">
                {{ countryName }}
            </span>
        </CompassFormItem>
        <CompassFormItem
            :label="$t.__('CompanyInformation.legal_information.siren_label')"
            orientation="horizontal"
        >
            <span class="typographies-paragraph-medium-regular">
                {{ data.legal_france.siren }}
            </span>
        </CompassFormItem>
        <CompassFormItem
            :label="$t.__('CompanyInformation.legal_information.siret_label')"
            orientation="horizontal"
        >
            <span class="typographies-paragraph-medium-regular">
                {{ data.legal_france.siret }}
            </span>
        </CompassFormItem>
        <CompassFormItem
            :label="$t.__('CompanyInformation.legal_information.company_name_label')"
            orientation="horizontal"
        >
            <span class="typographies-paragraph-medium-regular">
                {{ data.legal_name }}
            </span>
        </CompassFormItem>
        <CompassFormItem
            :label="$t.__('CompanyInformation.legal_information.vat_number_label')"
            orientation="horizontal"
        >
            <span class="typographies-paragraph-medium-regular">
                {{ data.legal_france.vat }}
            </span>
        </CompassFormItem>
        <CompassFormItem
            :label="$t.__('CompanyInformation.legal_information.legal_status_label')"
            orientation="horizontal"
        >
            <span class="typographies-paragraph-medium-regular">
                {{ data.legal_france.company_type }}
            </span>
        </CompassFormItem>
        <CompassFormItem
            :label="$t.__('CompanyInformation.legal_information.share_capital_label')"
            orientation="horizontal"
        >
            <span class="typographies-paragraph-medium-regular">
                {{ data.capital }}
            </span>
        </CompassFormItem>
        <CompassFormItem
            :label="$t.__('CompanyInformation.legal_information.naf_code_label')"
            orientation="horizontal"
        >
            <span class="typographies-paragraph-medium-regular">
                {{ data.legal_france.ape_naf_code }}
            </span>
        </CompassFormItem>
        <CompassFormItem
            :label="$t.__('CompanyInformation.legal_information.rcs_label')"
            orientation="horizontal"
        >
            <span class="typographies-paragraph-medium-regular">
                {{ data.legal_france.rcs_immatriculation }}
            </span>
        </CompassFormItem>
    </div>
</template>
<script>
export default {
    props: {
        data: {
            type: Object,
            required: true,
        },
        countries: {
            type: Array,
            required: true,
        },
    },
    computed: {
        countryName() {
            if (!this.data.country_code || this.countries.length === 0) {
                return '';
            }
            const country = this.countries.find(
                (country) => country.code.toLowerCase() === this.data.country_code.toLowerCase(),
            );
            return country?.name || '';
        },
    },
};
</script>
<style lang="scss" scoped>
.company-information-form-locked {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-3);

    :deep() {
        .compass-form-item--horizontal .compass-form-item__label--medium {
            min-height: auto;
        }
    }
}
</style>
